// extracted by mini-css-extract-plugin
export var aircallIframe = "_de-3";
export var fabContainer = "_de-5";
export var fabRinging = "_de-6";
export var loadingOverlay = "_de-4";
export var pulse = "_de-7";
export var widgetContent = "_de-2";
export var widgetPanel = "_de-0";
export var widgetPanelExpanded = "_de-1";